var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('b-container',{staticClass:"res-footer mr-2",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"text-right",attrs:{"md":"12"}},[_c('span',[_vm._v("© Company admin client 2020")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }